<template>
  <Modal :id="'cmp-file-uploader'" @cancelled="onCancelClick">
    <template slot="header">Files</template>
    <template slot="body">
      <FileDropzone @filedrop="onFileDropped">
        <div class="dt-modal--subtitle">Upload New File</div>
        <v-layout v-if="!this.file" row wrap class="file-section">
          <div class="button-container">
            <button
              class="dt-button s4 select-file"
              id="selectNewFile"
              @click="onSelectNewFile"
            >
              <div class="dt-icon-container">
                <img src="static/icons/plus.svg" class="dt-icon v7" alt />
              </div>
              <span class="button-text">Select New File</span>
            </button>
            <input
              type="file"
              id="filepicker"
              @change="onFilePickerChange"
              style="visibility: hidden; display: none"
              name="filepicker"
            />
          </div>
          <div class="middle-or">
            <div>or</div>
          </div>
          <div class="file-dropzone">
            <div class="dt-icon-container">
              <img
                src="static/icons/modal/document-grey.svg"
                class="dt-icon v7"
                alt
              />
            </div>
            <span class="dropzone-text" v-if="!file">Drag & Drop</span>
            <!-- <div v-else class="file-info">
              <span class="file-name">{{file.name}}</span>
              <span class="file-size">({{formatBytes(file.size)}})</span>
            </div> -->
          </div>
        </v-layout>
        <div class="file-upload-list">
          <v-layout
            class="file-upload-list-item"
            v-if="file && !fileUploadingFlag"
            row
            wrap
          >
            <div class="dt-icon-container">
              <img
                src="static/icons/modal/document-grey.svg"
                class="dt-icon v7"
                alt
              />
            </div>
            <div class="file-name vermid2">
              {{ file.name }}
            </div>
            <div class="file-description">
              <InputField
                :value="fileDescription"
                :placeholder="$t('description')"
                :config="{
                  borderStyle: 'around',
                  noicon: true,
                }"
                @keyup="(e) => (fileDescription = e.target.value)"
              ></InputField>
            </div>
            <div class="file-internal">
              <div class="dt-checkbox v2 s1 vermid2">
                <input
                  type="checkbox"
                  @click="(e) => onInternalUseOnlyCheckboxChange(e)"
                  :name="'file_internal_use_only'"
                  :id="'file_internal_use_only'"
                  :checked="fileInternalUse == '1'"
                />
                <div class="checkmark"></div>
              </div>
              <div class="file-internal-text vermid2">Internal Use Only</div>
            </div>
          </v-layout>
        </div>
        <v-layout
          row
          wrap
          v-if="file && !fileUploadingFlag"
          style="margin-top: 15px"
        >
          <button class="dt-button v1 s6" @click="onUploadFile">
            Upload File
          </button>
        </v-layout>
        <div class="ut-colcen" v-if="fileUploadingFlag" style="height: 85px">
          <div class="ut-rowcen">
            <img src="static/icons/loading.gif" alt />
          </div>
        </div>

        <div
          class="choose-existing-container"
          v-if="isShowChooseExisting && !documentRelationLoadingFlag"
        >
          <!-- <v-layout row wrap>
            <v-flex md12 class="section-name"
              >Choose from Existing Files</v-flex
            >
          </v-layout> -->
          <table class="dt-table2 dtplugins-artwork-artwork_list">
            <thead class="dt-table2--head">
              <tr
                class="dt-table2--row"
                :style="{
                  'margin-right': hRowMarginRight,
                }"
              >
                <th class="dt-table2--column"></th>
                <th class="dt-table2--column">File</th>
                <th class="dt-table2--column">Description</th>
                <th class="dt-table2--column">File Type</th>
              </tr>
            </thead>
            <tbody class="dt-table2--body">
              <tr
                class="dt-table2--row"
                v-for="file in files"
                :key="file.file_id"
              >
                <td class="dt-table2--column">
                  <label
                    class="radio-container"
                    for="file.file_id"
                    @click.stop="(e) => onInputChange(e, file)"
                  >
                    <input
                      type="radio"
                      :id="file.file_id"
                      :checked="file.file_link == artwork"
                      @click.stop="(e) => onInputChange(e, file)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td class="dt-table2--column txtov">
                  <div class="ut-flex">
                    <img
                      :src="file['file_link']"
                      width="30"
                      height="30"
                      style="min-width: 30px"
                    />
                    <div
                      style="margin-left: 8px; max-width: calc(100% - 50px)"
                      class="ut-colcen txtov ut-block ut-my-auto"
                    >
                      {{ file["file_name"] }}
                    </div>
                  </div>
                </td>
                <td class="dt-table2--column">
                  {{ file["file_description"] }}
                </td>
                <td class="dt-table2--column">
                  {{ file["file_type"] }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <v-container>
          <v-layout row wrap justify-center>
          </v-layout>
          </v-container>-->
        </div>
        <div
          class="ut-colcen"
          v-if="documentRelationLoadingFlag"
          style="margin-top: 15px"
        >
          <div class="ut-rowcen">
            <img src="static/icons/loading.gif" alt />
          </div>
        </div>
      </FileDropzone>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button class="dt-button v1 s6" @click="onOKClick">OK</button>
    </template>
  </Modal>
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import FileDropzone from "../file-uploader/file-dropzone";

import { FileService } from "../file-uploader/file.service";
import { unrelatedDocumentView } from "../file-uploader/file.model";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet, formatBytes, snakeCaseToWords } from "../../utility";

import Modal from "../modal/modal";
import { ArtworkService } from "./artwork.service";

export default {
  components: {
    InputField,
    // vueDropzone,
    FileDropzone,
    Modal,
  },
  props: {
    artwork: {
      type: String,
    },
    externalId: {
      required: true,
    },
    externalTable: {
      required: true,
    },
    externalKey: {
      required: true,
    },
    section: {
      required: true,
    },
  },
  data: function () {
    return {
      selectedFiles: new Set(),
      searchString: "",
      searchSubject$: new Subject(),
      dropZoneOptions: {
        url: "https://staging.detailsdetails.eu/berlin3/files.pl",
        withCredentials: true,
        autoProcessQueue: false,
        maxFiles: 1,
        paramName: "file_name",
        createImageThumbnails: false,
      },
      files: [],
      file: null,
      fileObjects: [],
      fileDescription: "",
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      fileInternalUse: "0",

      fileUploadingFlag: false,
      documentRelationLoadingFlag: false,
    };
  },
  mounted: async function () {
    if (this.isShowChooseExisting) {
      const fileResponse = await ArtworkService.fetchRelatedFiles({
        externalId: this.externalId,
        section: this.section,
        externalKey: this.externalKey,
      });

      this.files = fileResponse?.data?.artwork_related_files || [];

      console.log(fileResponse);

      this.$subscribeTo(
        this.searchSubject$
          .asObservable()
          .pipe(distinctUntilChanged(), debounceTime(500)),
        (searchString) => {
          FileService.findFileByName({
            key: searchString,
            externalId: this.externalId,
            externalTable: this.externalTable,
          }).then((res) => {
            this.files = unrelatedDocumentView(res);
          });
        }
      );
    }
  },
  computed: {
    hRowMarginRight: function () {
      if (this.files.length > 380 / 28) {
        return "28px";
      }
    },
    isShowChooseExisting: function () {
      return this.externalId && this.externalTable;
    },
  },
  methods: {
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    },
    onCancelClick: function (event) {
      this.resetData();
      this.$emit("cancelled", true);
    },
    onOKClick: function (event) {
      if (this.file) {
        this.onUploadFile();
      } else {
        this.$emit("ok", true);
      }
    },
    emitFileDone(res) {
      this.$emit("done", {
        files: res.data.files,
        file: res.data.files.find(
          (f) => f?.file_id == res?.data?.file?.file_id
        ),
        externalId: this.externalId,
        externalTable: this.externalTable,
      });
    },
    onSelectNewFile: function (event) {
      // document.querySelector('#fileDropzone').click();
      document.querySelector("#filepicker").click();
    },
    fileAdded: function (file) {
      console.log(file, this.$refs.fileDropzone);
      this.file = file;
      const size = formatBytes(file.size);
    },
    formatBytes: function (size) {
      return formatBytes(size);
    },
    fileSending: function (file, xhr, formData) {
      //formData.append("returnType", "json");
      formData.append("external_id", this.externalId);
      formData.append("external_table", this.externalTable);
      formData.append("action", "upload_document_new");
      formData.append("section", "bookings");
      formData.append("file_description", "");
      formData.append("private", 0);
    },
    onUploadFile: function (event) {
      // this.$refs.fileDropzone.processQueue();
      this.uploadFile();
    },
    resetData: function () {
      this.file = null;
      this.selectedFiles = new Set();
      this.fileDescription = "";
      this.fileInternalUse = "0";
    },
    onCancelUpload: function (event) {
      this.resetData();
      this.$emit("cancelled", true);
      this.$refs.fileDropzone.removeAllFiles();
    },
    fileUploadSuccess: function (res) {
      // this.$emit("done", res);
      this.emitFileDone(res);
    },
    constructFormDataFromFile: function (file) {
      // console.log(file);
      const formData = new FormData();

      formData.append("file_name", file);

      formData.append("returnType", "json");
      formData.append("external_id", this.externalId);
      formData.append("external_table", this.externalTable);
      formData.append("action", "upload_document_new");
      formData.append("section", "bookings");
      formData.append("file_description", this.fileDescription || file.name);
      formData.append("private", this.fileInternalUse);

      return formData;
    },
    uploadFile: function () {
      // const files = this.file;

      const formData = this.constructFormDataFromFile(this.file);
      // console.log(this.file);
      this.fileUploadingFlag = true;
      FileService.uploadFile(formData).then((res) => {
        this.fileUploadingFlag = false;
        if (this.isShowChooseExisting) {
          // this.$emit("done", res);
          this.emitFileDone(res);
          this.resetData();
        } else {
          this.onCancelUpload();
        }
      });
    },

    uploadAllFiles: function () {
      // for (const index in this.fileObjects) {
      //   const formData = this.constructFormDataFromFile(this.fileObjects[index]);
      //   const onUploadProgress = (event) => {
      //     this.fileObjects[index].percentage = parseInt(Math.round(event.loaded * 100 / event.total));
      //     console.log(this.fileObjects[index].percentage);
      //   }
      //   FileService.uploadFile(formData, onUploadProgress).then(res => {
      //   });
      // }
    },

    onFileDropped: function (files) {
      if (files.length == 0) {
        return;
      }
      const file = files[0];
      this.file = file;

      // After Multiple File is supported
      // this.fileObjects = files.map(e => ({file: e}));
    },
    onFilePickerChange: function (event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.file = files[0];
      }
    },
    onInternalUseOnlyCheckboxChange: function (e) {
      this.fileInternalUse = e.target.checked ? "1" : "0";
    },
    snakeCaseToWords: snakeCaseToWords,
    onInputChange: function (e, file) {
      if (file.file_link !== this.artwork) {
        this.$emit("artworkChanged", file);
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" >
.contact-search {
  height: 30px;
  width: 290px;
}
.dt-table2--body {
  min-height: none !important;
}
.dtplugins-artwork-artwork_list {
  margin-top: 10px;
  --row-margin: 0px;
  --row-margin-header: 0px;

  tbody {
    height: 100%;
    min-height: none !important;
    tr {
      height: 40px;
    }
  }

  .dt-table2--column {
    &:first-child {
      max-width: 30px;
    }

    &:nth-child(2) {
    }
    &:nth-child(3) {
      flex: 1.5;
    }
    &:nth-child(4) {
      flex: 0.5;
    }
  }
}

.section-name {
  color: var(--text-3);
  margin: 15px 0px;

  &.upload-new {
    margin-top: 0px;
  }
}

.file-section {
  margin-left: -8px;
  .middle-or {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 32px;
  }
  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;

    button.select-file {
      display: flex;
      width: 138px;

      .dt-icon-container {
        // img {
        //   padding: 2px;
        // }
      }

      .button-text {
        // margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;
      }
    }
  }

  .file-dropzone {
    width: 150px;
    height: 60px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    text-align: center;
    border: 1px dashed var(--sprt-4);

    .dt-icon-container {
      margin-left: auto;
      margin-right: auto;

      height: 30px;
      margin-top: 2px;
    }

    .dropzone-text {
      color: var(--col-d9);
    }
  }

  .file-info {
    display: flex;
    justify-content: center;
    .file-name {
      max-width: 90px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 2px;
    }
    .file-size {
    }
  }
}
</style>

<style lang="scss">
.cmp-file-uploader {
  .dt-table2--body {
    min-height: none !important;
  }
  .file-upload-list {
    overflow: auto;
    max-height: 250px;

    .file-upload-list-item {
      padding: 5px 0px;

      &:not(:last-child) {
        border-bottom: 1px solid var(--sprt-85);
      }

      .file-name {
        //TEMP
        margin-right: 30px;
      }
      .file-bar {
        display: flex;
        margin-left: 12px;
        // margin-right: 50px;

        .progress-bar-container {
          width: 60px;
          height: 5px;

          margin-right: 12px;
          border-radius: 30px;
          background: gray;
        }
        .file-close {
        }
      }
      .file-description {
        flex: 1;
        // width: 230px;

        //TEMP
        // min-width: 252px;
        // max-width: 272px;
      }
      .file-internal {
        display: flex;
        margin-left: 15px;

        .file-internal-text {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
